import React from 'react';
import './App.css';
import InfiniteScrollPhotos from './InfiniteScrollPhotos';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Payton Roper</h1>
      </header>
      <main className="App-main">
        <InfiniteScrollPhotos />
      </main>
      <footer className="App-footer">
        <p></p>
      </footer>
    </div>
  );
}

export default App;

